import React, { useContext } from 'react'
import { ChakraProvider } from '@chakra-ui/react'
import routes from './routes'
import { useRoutes, HashRouter } from 'react-router-dom'
import { Context } from './component/store'
// import { AiOutlineConsoleSql } from 'react-icons/ai'


const App = () => {

  
  const auth = localStorage.getItem('token')
  // const user = JSON.parse(localStorage.getItem('user'))
  const { userData } = useContext(Context)
  const user = userData

 
  const routing = useRoutes(routes((auth !== null ? true : false), user?.UserGroupPermission || [], user?.userGroupMember || []))
  return (
    <ChakraProvider>
      {(Object.keys(user).length > 0 || auth === null) && routing}
    </ChakraProvider>
    // <Router>
    //     <Route exact path="/" component={OrdersAll} />
    //     <Route exact path="/orders/all" component={<div>Hu</div>} />
    //     <Route exact path="/orders/verified" component={OrdersVerified} />
    //     <Route exact path="/orders/picked-up" component={OrdersPickedUp} />
    //     <Route exact path="/orders/in-transit" component={OrdersInTransit} />
    //     <Route exact path="/orders/delivered" component={OrdersDelivered} />
    //     <Route exact path="/orders/canceled" component={OrdersCanceled} />
    //     <Route exact path="/orders/fulfilled" component={OrdersFulfilled} />
    //     <Route
    //       exact
    //       path="/orders/pending-fulfillment"
    //       component={OrdersPendingFulfillment}
    //     />
    //     <Route
    //       exact
    //       path="/orders/ready-fulfillment"
    //       component={OrdersReadyFulfillment}
    //     />
    //     <Route component={NotFound} />
    // </Router>
  );
}

export default App